/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

import { decodeHTML, removeTags } from '../../../assets/ts/general/general'
import DueOutAcknowledgePopup from '../../../components/page-overlay/due-out-acknowledge-popup'
import PageOverlayBusy from '../../../components/page-overlay/page-overlay-busy'
import useDueouts from '../../../hooks/dueout/use-dueouts'
import PageHeader from '../../../layouts/header/page-header'
import { PreviousPageContext } from '../../../store/previous-page-provider'
import { RoleContext } from '../../../store/role-context-provider'
import { UserContext } from '../../../store/user-context-provider'
import { ACTIONS, DUEOUTS_STATUS } from '../../../utils/constants/global-constants'
import { PersonDetails } from '../../../utils/constants/global-interfaces'
import ActionButtonsContainer from '../action-buttons-container/action-buttons-container'
import Checklist from '../checklist/checklist'
import Details from '../details/details'
import '../details/details.css'
import { detailsitems, dueoutdetailsitems } from '../details/dueout-details-data'
import Discussions from '../discussions/discussions'
import DetailViewFiles from '../files/detail-view-files'
import DueOutProgressBar from '../progress-steps/due-out-progress-bar'
import TeamMembers from '../team-members/team-members'

const DueoutDetailView = (props: any) => {
  const { guid } = useParams()
  const { me } = useContext(UserContext)
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)
  const { dueouts, dueoutsAreLoading, refetch } = useDueouts({ dueoutGuid: guid })
  const roleContext = useContext(RoleContext)
  const currentDueout = dueouts[0]

  const [currentUserRole, setCurrentUserRole] = useState<string>('')
  const [currentAction, setCurrentAction] = useState<string>('')
  const [acknowledgePopup, setAcknowledgePopup] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(dueoutsAreLoading)

  const [allFiles, setAllFiles] = useState<any>([])

  const description = useMemo(() => {
    return decodeHTML(currentDueout?.Description)
  }, [currentDueout])

  const customerDetailsItems = useMemo(() => detailsitems(currentDueout), [currentDueout])

  const dueOutDetailsItems = useMemo(() => dueoutdetailsitems(currentDueout), [currentDueout])
  const getSelectedFiles = (files: any, allFiles: any) => {
    setAllFiles(allFiles)
  }
  const hideButton = (action: string) => {
    if (
      action.toUpperCase() === ACTIONS.Closed.toUpperCase() ||
      action.toUpperCase() === ACTIONS.Canceled.toUpperCase()
    ) {
      return true
    } else {
      return false
    }
  }
  useEffect(() => {
    if (
      currentDueout?.StatusCode == DUEOUTS_STATUS.NOT_STARTED &&
      me.userId == (currentDueout?.Customer as PersonDetails)?.userID
    )
      setAcknowledgePopup(true)
  }, [currentDueout, me.userId])
  useEffect(() => {
      if (refresh) {
        // Logic to re-fetch data or re-render the component
        refetch()
        setRefresh(false)
      }
    }, [refresh])
  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (location && currentPage && currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes
  return (
    <>
      {isLoading && <PageOverlayBusy />}
      {!acknowledgePopup && (
        <PageHeader
          extras={
            <ActionButtonsContainer
              actionType='Dueout'
              currentUserRoleProps={{ currentUserRole, setCurrentUserRole }}
              data={currentDueout}
              isMenusExpanded={props?.isMenusExpanded}
              pageType='dueoutdetailview'
              refresh={refresh}
              setRefresh={setRefresh}
            />
          }
          name={`${currentDueout?.DueOutID} - ${currentDueout?.Subject}`}
          titleclass='color-primary'
        />
      )}
      <div className='pb-2 w-100'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-3 col-lg-2'>
              <div className='shadow card w-100 h-100'>
                <DueOutProgressBar
                  DueOut={currentDueout}
                  ItemGUID={guid}
                  refresh={refresh}
                  role={currentUserRole}
                  setCurrentAction={setCurrentAction}
                />
              </div>
            </div>
            <div className='col-sm-12 col-md-9 col-lg-6 col-xl-7'>
              <div className='shadow card w-100 mb-3'>
                <Details
                  currentInquiry={currentDueout}
                  customerDetails={customerDetailsItems}
                  description={description}
                  hideButton={hideButton(currentAction)}
                  inquiryDueoutDetails={dueOutDetailsItems}
                  roleContext={roleContext}
                  title={'Due Out Details'}
                />
              </div>
              <div className='shadow card w-100'>
                <Discussions
                  ItemGUID={guid}
                  allFiles={allFiles}
                  currentInquiry={currentDueout}
                  hideButton={hideButton(currentAction)}
                  isInquiry={false}
                  refresh={refresh}
                  role={currentUserRole}
                  setIsLoading={setIsLoading}
                />
              </div>
            </div>
            <div className='col-sm-12 col-md-12 col-lg-4 col-xl-3'>
              <Checklist
                category={currentDueout?.['Category/MetadataValue']}
                subCategory={currentDueout?.['SubCategory/MetadataValue']}
              />
              <DetailViewFiles
                ItemGUID={guid}
                allFiles={allFiles}
                currentInquiry={currentDueout}
                getSelectedFiles={getSelectedFiles}
                hideButton={hideButton(currentAction)}
                isInquiry={false}
                role={currentUserRole}
                setAllFiles={setAllFiles}
              />
              <TeamMembers
                currentInquiry={currentDueout}
                hideButton={hideButton(currentAction)}
                isInquiry={false}
                refresh={refresh}
                role={currentUserRole}
                setRefresh={setRefresh}
              />
            </div>
          </div>
        </div>
      </div>
      {acknowledgePopup && <DueOutAcknowledgePopup dueout={currentDueout} />}
    </>
  )
}
export default DueoutDetailView
